import { Link } from "react-router-dom";

export interface Crumb {
  /** Visible label. The caller resolves i18n. */
  label: string;
  /** Target route. Omit on the active (last) crumb. */
  href?: string;
}

interface Props {
  crumbs: Crumb[];
}

/**
 * Generic breadcrumb. Each crumb renders as a ``<Link>`` when ``href``
 * is provided, otherwise as the active span. Used by every
 * configurator page through ``ConfiguratorPageShell``; the page builds
 * the crumb list with i18n strings so this stays process-agnostic.
 */
export function Breadcrumb({ crumbs }: Props): JSX.Element {
  const linkCls = "text-ink-3 hover:text-ink";
  const activeCls = "text-ink";
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-2 text-[12px] text-ink-3"
      data-testid="page-breadcrumb"
    >
      {crumbs.map((c, i) => (
        <span key={`${c.label}-${i}`} className="flex items-center gap-2">
          {i > 0 && <span aria-hidden="true">/</span>}
          {c.href ? (
            <Link to={c.href} className={linkCls}>
              {c.label}
            </Link>
          ) : (
            <span className={activeCls}>{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
